import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=85f5b17a&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('85f5b17a', component.options)
    } else {
      api.reload('85f5b17a', component.options)
    }
    module.hot.accept("./Download.vue?vue&type=template&id=85f5b17a&", function () {
      api.rerender('85f5b17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Download.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Download.vue
// module id = YW9k
// module chunks = 0